var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecieptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 91,
    viewBox: "0 0 76 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4024 91.0001H10.5976L0 47.1316H10.5976L65.4024 91.0001Z",
    fill: "#4A3163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5976 0H56.0159V76.1355H10.5976V0Z",
    fill: "#BE9FE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2908 7.43237H60.7092V83.5678H15.2908V7.43237Z",
    fill: "#9CD3FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4024 91V26.1035L56.016 14.8645H19.9841V91H65.4024Z",
    fill: "#CDE9FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0159 26.1035H65.4024L56.0159 14.8645V26.1035Z",
    fill: "#BE9FE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3705 32.8108H56.0159V34.6235H29.3705V32.8108ZM29.3705 40.2431H56.0159V42.0558H29.3705V40.2431ZM29.3705 47.8566H56.0159V49.6694H29.3705V47.8566Z",
    fill: "#573A7A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47.1316L65.4024 91.0001H10.5976L21.1952 56.1953H52.988L56.0159 47.1316H76Z",
    fill: "#573A7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9443 47.1316C69.9443 47.1316 60.1036 80.3049 22.255 91.0001H65.4024L76.0001 47.1316H69.9443Z",
    fill: "#4A3163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecieptIcon);
export default __webpack_public_path__ + "static/media/recieptIcon.a124fe6c9fdc1ff97bc80ccb33412fea.svg";
export { ForwardRef as ReactComponent };